// NavDistricts.js
import React from "react";

const NavCampaign = () => {
  return (
    <fragment>
      <div class="bitdFont morkBorgText" style={{ textAlign: "center" }}>
        💀{" "}
        <a
          style={{ color: "yellow" }}
          href="./blades-in-the-dark-campaign-introduction"
        >
          Campaign
        </a>{" "}
        💀{" "}
        <a
          style={{ color: "yellow" }}
          href="./blades-in-the-dark-campaign-districts"
        >
          Districts
        </a>{" "}
        💀
      </div>
    </fragment>
  );
};

export default NavCampaign;
